import { generateUtilityClass, generateUtilityClasses } from "@suid/base";
export function getListItemButtonUtilityClass(slot) {
    return generateUtilityClass("MuiListItemButton", slot);
}
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected",
]);
export default listItemButtonClasses;
